module.exports = __webpack_public_path__ + "img/tenant.a0730628.jpg";